import { COLORS as COLORS_LA } from "modules/pranna/la/components/ColorPalette/constants"
import { COLORS as COLORS_MX } from "modules/pranna/mx/components/ColorPalette/constants"
import { isLATAM } from "services/instances"

export const COLORS = !isLATAM() ? COLORS_MX : COLORS_LA
